import React from 'react';

import ReactDOM from 'react-dom';

import '@app/i18n';
import {App} from '@app/App';
import {fetchProfileFx} from '@entities/user/model';

fetchProfileFx()
    .catch(console.log)
    .finally(() => {
        import('./createInvoiceAdapter').then(() => {
            ReactDOM.render(<App />, document.getElementById('root'));
        });
    });
